import OnlyForPublicRoute from "../components/OnlyForPublicRoute";
import OnlyForSomeRolesRoute from "../components/OnlyForSomeRolesRoute";
import PrivateRoute from "../components/PrivateRoute";

export const isRoutePermitted = (userRoles, roles = []) => {
  let isPermitted = false;
  if (roles.length === 0) isPermitted = true;
  mainLoop: for (let i = 0; i < userRoles.length; i++) {
    for (let j = 0; j < roles.length; j++) {
      if (userRoles[i] === roles[j]) {
        isPermitted = true;
        break mainLoop;
      }
    }
  }
  return isPermitted;
};

export const createRoute = ({
  element,
  roles = [],
  isPrivate = false,
  isOnlyForPublic = false,
  ...rest
}) => {
  let elementToRender = element;
  if (Boolean(roles.length)) {
    elementToRender = (
      <PrivateRoute>
        <OnlyForSomeRolesRoute roles={roles}>
          {elementToRender}
        </OnlyForSomeRolesRoute>
      </PrivateRoute>
    );
  } else {
    if (isPrivate)
      elementToRender = <PrivateRoute>{elementToRender}</PrivateRoute>;
    if (isOnlyForPublic)
      elementToRender = (
        <OnlyForPublicRoute>{elementToRender}</OnlyForPublicRoute>
      );
  }
  return {
    element: elementToRender,
    roles,
    ...rest,
  };
};

export const formatRoutes = (routes) => {
  return routes.map((route) => {
    return Boolean(route.children)
      ? { ...route, children: formatRoutes(route.children) }
      : createRoute(route);
  });
};
